<main class="signin-container">
  <div class="wrapper">
    <!--RETURN TO BEYOND HOME-->
    <div class="beyond-logo-login">
      <a routerLink="/home" title="Education home" routerLinkActive="active">Genesys | Education</a>
    </div>
    <!--END RETURN TO BEYOND HOME-->

    <!--TODO: Fix this error handling in next sprint-->
    <!--INVALID ERROR MESSAGE-->
    <div *ngIf="!isAuthenticating" class="app-login-wrapper">
      <div class="app-login">
        <p>
          We are unable to authenticate you at this time. If the problem persists, or you feel that
          this is in error, please contact us at
          <a class="gen-primary-link--accesible with-underline" href="mailto:beyond@genesys.com">
            beyond&#64;genesys.com
          </a>
        </p>
        <a class="gen-primary-link" routerLink="/home" routerLinkActive="active">Go to homepage</a>
      </div>
    </div>
    <!--END INVALID ERROR MESSAGE-->
    <!--SIGN-IN FORM-->
    <div *ngIf="isCookieSet; then thenBlock; else elseBlock"></div>
    <ng-template #thenBlock>
      <app-loading-page></app-loading-page>
    </ng-template>
    <ng-template #elseBlock>
      <div class="signin" *ngIf="!isCookieSet">
        <form class="signInForm" [formGroup]="loginForm" (ngSubmit)="signInWithCredentials()">
          <fieldset>
            <ng-container *ngIf="(isAuthenticated$ | async) === false; else signout">
              <legend>Sign in</legend>
              <!--SHOW INVALID LOGIN ERROR MESSAGE-->
              <div *ngIf="showLoginError" class="login-error">
                <i class="icon red small warning"></i
                ><span [innerHTML]="defaultErrorMessage | safe : 'html'"></span>
              </div>
              <input
                type="text"
                placeholder="Username"
                autocomplete="off"
                class="form-spacing"
                [ngClass]="{ 'is-invalid': invalid }"
                formControlName="username" />
              <input
                type="password"
                placeholder="Password"
                autocomplete="off"
                class="form-spacing"
                [ngClass]="{ 'is-invalid': invalid }"
                formControlName="password" />
              <div class="field-row">
                <!--SUBMIT SIGN IN-->
                <input
                  class="btn btn-brand btn-elastic field-submit"
                  type="submit"
                  value="Sign in" />
                <!--FORGOT PASSWORD-->
                <a
                  class="field-forgot-password"
                  href="https://apps.genesys.com/pcodebroker/resetPcode.aspx"
                  rel="noopener noreferrer nofollow">
                  Forgot password?
                </a>
              </div>
              <!--CUSTOM DIVIDER-->
              <div *ngIf="showOktaLoginButton" class="separator">or</div>
              <!--END CUSTOM DIVIDER-->
            </ng-container>
            <ng-template #signout>
              <p class="margin-bottom-large text-align-center">You are already signed in.</p>
              <button
                class="btn btn-brand-inverse btn-elastic field-okta-login"
                (click)="signOut()">
                Sign out
              </button>
            </ng-template>
            <!--END SIGN IN OKTA-->
          </fieldset>
        </form>
        <!--SIGN IN OKTA-->
        <div class="sign-in-okta">
          <ng-container *ngIf="(isAuthenticated$ | async) === false">
            <button
              *ngIf="showOktaLoginButton"
              class="btn btn-brand-inverse btn-elastic field-okta-login"
              (click)="signInWithRedirect()">
              Sign in with Okta
            </button>
          </ng-container>
        </div>
        <!--AGENT PLATFORM SIGN IN-->
        <div>
          <p class="margin-top-small text-align-center smaller-text bold">
            Looking for Agent Platform (AP) Training? Sign in
            <a
              class="red gen-primary-link with-underline"
              target="_blank"
              rel="noopener noreferrer nofollow"
              href="{{ environment.docebo.agent_platform_login_url }}">
              here
            </a>
            .
          </p>
        </div>
        <!--END AGENT PLATFORM SIGN IN-->
        <!--SIGN-UP LINK-->
        <div class="sign-up">
          <span>
            New user?
            <a
              href="{{ environment.beyondRegistration.url + '/education-registration' }}"
              rel="noopener noreferrer nofollow">
              Sign up
            </a>
          </span>
        </div>
        <!--END SIGN-UP LINK-->
      </div>
    </ng-template>
    <!--END SIGN-IN FORM-->
  </div>
</main>
